/* @flow */

import * as React from "react";

import { Clearfix } from "react-bootstrap";

import Tracking from "shared/src/uidispatcherapi/Tracking";

/**
 * This util takes an array of React elements and adds clearfix elements according to the
 * numbers in the config object.
 * If md is 3 for example, then a clearfix-md will be added every three elements.
 */
const ClearFixUtil = {
    addClearfix(
        arr: Array<any>,
        config: {
            xs: number;
            sm: number;
            md: number;
            lg: number;
            xl: number;
        }
    ): Array<any> {
        if (!config) {
            Tracking.trackError("searchdiscover", "ui", "ClearFixUtil", "No config object present for ClearfixUtil.");
            return arr;
        }
        const result: any[] = [];
        (arr ?? []).forEach((elem: any, index: number) => {
            if (index > 0) {
                if (config.xs > 1 && index % config.xs === 0) {
                    result.push(<Clearfix visibleXsBlock key={"clearfix-xs-" + index} />);
                }
                if (config.sm > 1 && index % config.sm === 0) {
                    result.push(<Clearfix visibleSmBlock key={"clearfix-sm-" + index} />);
                }
                if (config.md > 1 && index % config.md === 0) {
                    result.push(<Clearfix visibleMdBlock key={"clearfix-md-" + index} />);
                }
                if (config.lg > 1 && index % config.lg === 0) {
                    result.push(<Clearfix visibleLgBlock key={"clearfix-lg-" + index} />);
                }
                if (config.xl > 1 && index % config.xl === 0) {
                    result.push(<Clearfix className="visible-xl" key={"clearfix-xl-" + index} />);
                }
            }
            result.push(elem);
        });
        return result;
    }
};

export default ClearFixUtil;

export const { addClearfix } = ClearFixUtil;
